/**
 * Scroll reveal for NOA Dessert Evolution section.
 * Re-inits on Theme Editor section load.
 */
(function () {
  function init() {
    document.querySelectorAll('[data-noa-evolution-root]').forEach(function (root) {
      if (root.dataset.noaEvoInit === '1') return;
      root.dataset.noaEvoInit = '1';

      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var els = root.querySelectorAll('[data-reveal]');

      if (reduce || !('IntersectionObserver' in window)) {
        els.forEach(function (el) {
          el.classList.add('is-inview');
        });
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-inview');
            }
          });
        },
        { root: null, rootMargin: '0px 0px -10% 0px', threshold: 0.06 }
      );

      els.forEach(function (el) {
        io.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector('[data-noa-evolution-root]')) {
      ev.target.querySelectorAll('[data-noa-evolution-root]').forEach(function (r) {
        delete r.dataset.noaEvoInit;
      });
      init();
    }
  });
})();
